import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { QuizProgress } from '../models';

export const quizProgressActions = createActionGroup({
    source: 'Quiz Progress',
    events: {
        'Get Progress': props<{ quizId: string }>(),
        'Get Progress Success': props<{ payload: QuizProgress }>(),
        'Get Progress Not Started': emptyProps(),
        'Get Progress Error': props<{ code: number }>(),

        'Save Answer': props<{ quizId: string; questionId: string; optionId: number }>(),
        'Save Answer Success': props<{ payload: QuizProgress }>(),
        'Save Answer Error': props<{ code: number }>(),

        Retry: props<{ quizId: string }>(),
        'Retry Success': emptyProps(),
        'Retry Error': props<{ code: number }>(),

        Clear: emptyProps(),
    },
});
